import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '@/components/ui/button'
import Modal, { hideModal, showModal } from '../../widgets/modal'
import { actions } from '../Customers/customers.slice'
import { actions as accountActions } from '../Account/account.slice'
import { selectFilters } from '../Customers/customers.selectors'
import { fetchCustomers } from '../Customers/customers.asynActions'
import { selectSelectedAccount } from '../Account/account.selector'
import { updateAccount } from '../Account/account.asyncActions'
import BusyIndicator, { REGIONS } from '../../widgets/busyIndicator'

const { setSelectedCustomerModal, setSelectedAccounts } = actions

const { resetSelectedAccount } = accountActions

const SwitchAccountTypeModal = () => {
	const dispatch = useDispatch()
	const resetModal = () => {
		dispatch(setSelectedCustomerModal(null))
	}
	const filters = useSelector(selectFilters)
	const selectedAccount = useSelector(selectSelectedAccount)
	const [isSubmitting, setIsSubmitting] = useState(false)

	useEffect(() => {
		dispatch(showModal())
	})

	const handleClose = () => {
		dispatch(hideModal())
		resetModal()
		dispatch(resetSelectedAccount())
	}

	const handleSwitchAccount = () => {
		setIsSubmitting(true)
		dispatch(
			updateAccount({
				accountId: selectedAccount.id,
				account: selectedAccount,
			})
		).then(({ payload }) => {
			payload &&
				dispatch(
					fetchCustomers({
						filters,
						useCaching: false,
					})
				)
			dispatch(resetSelectedAccount())
			dispatch(setSelectedCustomerModal(null))
			dispatch(setSelectedAccounts([]))
			setIsSubmitting(false)
		})
	}

	const footer = (
		<>
			<Button className='h-50 w-190' variant='outline' onClick={handleClose}>
				Cancel
			</Button>
			<Button
				className='h-50 w-190'
				onClick={() => handleSwitchAccount()}
				disabled={isSubmitting}
			>
				<BusyIndicator region={REGIONS.UPDATE_ACCOUNT_DETAILS}>
					Switch Account
				</BusyIndicator>
			</Button>
		</>
	)
	return (
		<Modal
			footer={footer}
			reset={resetModal}
			title='Switch Account Type'
			size='md'
		>
			<h6 className='mb-25'>
				This single FFL account will be switched to a multiple FFL account. This
				action can not be reverted once complete. Please click “Switch Account”
				button to complete the process.
			</h6>
		</Modal>
	)
}
export default SwitchAccountTypeModal
